import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from "history";
// import dotenv from 'dotenv';
// dotenv.config();
const browserHistory = createBrowserHistory();
var reactPlugin = new ReactPlugin();
var appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: `${process.env.REACT_APP_INSTRUMENTATION_KEY}`,
        extensions: [reactPlugin],
        extensionConfig: {
          [reactPlugin.identifier]: { history: browserHistory }
        },
        disableTelemetry: `${process.env.REACT_APP_DISABLE_TELEMETRY}` === 'true' ? true : false
    }
});
//console.log('Ikey ', `${process.env.REACT_APP_INSTRUMENTATION_KEY}` );
appInsights.loadAppInsights();

export { appInsights, reactPlugin, withAITracking };